import { takeLatest } from "redux-saga/effects"
import {
  addCommentCalenderAction,
  AddMenuCategoryAction,
  addMenuItemsActions,
  DeleteMenuCategoryAction,
  deleteMenuItemAction,
  deleteRaffleContestAction,
  deleteWineMonthAction,
  EditCommentCalenderAction,
  EditMenuCategoryAction,
  editRaffleContestAction,
  editWineOfTheMonthItemAction,
  getBarMenuPeriodAction,
  getFoodItemsAction,
  getLeaderboardDataAction,
  getMenuPeriodAction,
  getRaffleListDataAction,
  getRaffleSingleDataAction,
  getSingleUserDataGraphAction,
  getSingleWineMonthDataAction,
  getWineMenuPeriodAction,
  getWineMonthAction,
  raffleTicketAction,
  updateFoodItemsAction,
  moveFoodItemCategoryAction,
  reorderMenuItemsAction,
  reorderMenuCategoriesAction,
  uploadMenuItemAction,
  uploadPDFThumbnailAction,
  uploadTastingNotesImagesAction,
  uploadWineOfTheMonthAction,
  WineMonthVideoThumbnailAction,
  addWineMenuItemsAction,
  getWineItemsAction,
  updateWineItemsAction,
  deleteWineItemAction,
  addBarMenuItemsAction,
  getBarItemsAction,
  updateBarItemsAction,
  deleteBarItemAction,
  getNewSpiritCountAction,
  getGamificationLeaderboardDataAction,
  getMenuSubCategoryAction,
  uploadMenuBulkAction,
  uploadDidYouKnowImageAction,
  uploadHistoryMediaAction,
  searchDidYouKnowImagesAction,
  confirmDidYouKnowImageAction,
  getWeeklyChallengeAction,
  getNextWeeklyChallengeAction,
  getLastWeeklyChallengeAction,
  getPreviousToLastWeeklyChallengeAction,
  editWeeklyChallengeAction,
  getWeeklyQuizAction,
  getNextWeeklyQuizAction,
  getLastWeeklyQuizAction,
  getPreviousToLastWeeklyQuizAction,
  editWeeklyQuizAction,
  viewWeeklyChallengeAction,
  viewWeeklyQuizAction,
  getViewChallengeQuestionsAction,
  getViewQuizQuestionsAction,
  deleteChallengeQuestionAction,
  editChallengeQuestionAction,
  getWeeklyQuestionsBankAction,
  ReplaceChallengeMenuItemAction,
  addWeeklyManualQuestionToBankAction,
  getWeeklyCategoryMenuItemAction,
  generateWeeklyQuestionAction,
  addQuestionToChallengeAction,
  addToWeeklyQuestionBankAction,
  deleteWeeklyQuestionFromBankAction,
  generateSoundbitesAction,
  updateQuizQuestionsAction,
  addWeeklyManualQuestionV2ToBankAction,
  uploadBulkQuestionAction,
  bulkDeleteQuestionsAction,
  setupWeeklyQuizzesAction,
  setupWeeklyChallengesAction,
  getSoundbiteVoiceIdsAction,
  swapWeeklyChallengesAction,
  uploadMenuForReviewAction,
  getReviewMenuCategoriesAction,
  getReviewMenuPeriodAction,
  getReviewBarMenuPeriodAction,
  getReviewWineMenuPeriodAction,
  getReviewSpiritCMSAction,
  getReviewMenuSubCategoryAction,
  publishReviewMenuAction,
  getUploadStatusAction,
  exportMenuListAction
} from "../actions"

import {
  addarchiveSpiritItems,
  AddBarMenuCategory,
  addBarMenuItems,
  addCommentCalender,
  addMenuCategory,
  addMenuItems,
  addWineMenuItems,
  deleteBarMenuCategory,
  deleteBarMenuItem,
  deleteMenuCategory,
  deleteMenuItem,
  deleteRaffleContest,
  deleteSpiritMenuItem,
  deleteWineMenuItem,
  deleteWineOfTheMonthItem,
  editBarMenuCategory,
  editBarMenuItem,
  EditCommentCalender,
  editMenuCategory,
  editRaffleContest,
  editWineMenuItem,
  editWineOfTheMonthItem,
  getArchivedSpiritCMS,
  getBarItems,
  getBarMenu,
  getFoodItems,
  getLeaderboardData,
  getListWineMonth,
  getMenuPeriod,
  getRaffleListData,
  getRaffleSingleData,
  getSingleUserDataGraph,
  getSingleWineMonthData,
  getSpiritCMS,
  getWineItems,
  getWineMenu,
  importSpiritItem,
  raffleTicket,
  unArchiveBarItems,
  unArchiveItems,
  unArchiveSpiritsItems,
  unarchiveWineItem,
  updateFoodItems,
  moveFoodItemCategory,
  reorderMenuItems,
  reorderMenuCategories,
  uploadMenuItem,
  uploadPDFThumbnail,
  uploadTastingNotesImages,
  uploadWineOfTheMonth,
  uploadWineOfTheMonthThumbnail,
  getSpiritItems,
  updateSpiritItems,
  getNewSpiritCount,
  getGamificationLeaderboardData,
  getQuizLeaderBoardData,
  getMenuSubCategory,
  uploadMenuBulk,
  AddWineMenuCategory,
  editWineMenuCategory,
  deleteWineMenuCategory,
  unArchiveWineItems,
  uploadDidYouKnowImage,
  uploadHistoryMedia,
  searchDidYouKnowImages,
  confirmDidYouKnowImage,
  getWeeklyChallenge,
  getNextWeeklyChallenge,
  getLastWeeklyChallenge,
  getPreviousToLastWeeklyChallenge,
  editWeeklyChallenge,
  getWeeklyQuiz,
  editWeeklyQuiz,
  viewWeeklyChallenge,
  viewWeeklyQuiz,
  getViewChallengeQuestions,
  getViewQuizQuestions,
  deleteChallengeQuestion,
  editChallengeQuestion,
  weeklyCategory,
  getWeeklyQuestionsBank,
  ReplaceChallengeMenuItem,
  addWeeklyManualQuestionToBank,
  getWeeklyCategoryMenuItem,
  generateWeeklyQuestion,
  addQuestionToChallenge,
  addToWeeklyQuestionBank,
  deleteWeeklyQuestionFromBank,
  getNewGamificationLeaderboardData,
  getNewLeaderboardData,
  generateSoundbites,
  updateQuizQuestions,
  addWeeklyManualQuestionV2ToBank,
  uploadBulkQuestion,
  bulkDeleteQuestions,
  getComments,
  updateCommentStatus,
  getNextWeeklyQuiz,
  getLastWeeklyQuiz,
  getPreviousToLastWeeklyQuiz,
  generateDidYouKnow,
  generateHistory,
  setupWeeklyQuizzes,
  setupWeeklyChallenges,
  generateSoundbiteText,
  aiEnhanceField,
  enhanceDidYouKnowField,
  removeImageBackground,
  getSoundbiteVoiceIds,
  swapWeeklyChallenges,
  uploadMenuForReview,
  getReviewMenuCategories,
  getReviewMenuPeriod,
  getReviewBarMenuPeriod,
  getReviewWineMenuPeriod,
  getReviewSpiritCMS,
  getReviewMenuSubCategory,
  publishReviewMenu,
  getUploadStatus,
  exportMenuList
} from "./user"
import {
  addarchiveSpiritItemsAction,
  AddBarMenuCategoryAction,
  archiveSpiritItemsAction,
  DeleteBarMenuCategoryAction,
  EditBarMenuCategoryAction,
  getArchivedSpiritCMSAction,
  getSpiritCMSAction,
  importSpiritItemAction,
  unArchiveBarItemsAction,
  unArchiveItemsAction,
  unArchiveSpiritsItemsAction,
  unarchiveWineItemsAction,
  deleteSpiritMenuItemAction,
  getSpiritItemsAction,
  updateSpiritItemsAction,
  AddWineMenuCategoryAction,
  editWineMenuCategoryAction,
  deleteWineMenuCategoryAction,
  unArchiveWineItemsAction,
  getQuizLeaderBoardDataAction,
  weeklyCategoryAction,
  getNewGamificationLeaderboardDataAction,
  getNewLeaderboardDataAction,
  getCommentsAction,
  updateCommentStatusAction,
  generateDidYouKnowAction,
  generateHistoryAction,
  generateSoundbiteTextAction,
  aiEnhanceFieldAction,
  enhanceDidYouKnowFieldAction,
  removeImageBackgroundAction
} from "../actions/user"

export default function* marketingWatcher() {
  yield takeLatest(raffleTicketAction, raffleTicket)
  yield takeLatest(WineMonthVideoThumbnailAction, uploadWineOfTheMonthThumbnail)
  yield takeLatest(uploadWineOfTheMonthAction, uploadWineOfTheMonth)
  yield takeLatest(getWineMonthAction, getListWineMonth)
  yield takeLatest(deleteWineMonthAction, deleteWineOfTheMonthItem)
  yield takeLatest(getSingleWineMonthDataAction, getSingleWineMonthData)
  yield takeLatest(editWineOfTheMonthItemAction, editWineOfTheMonthItem)

  yield takeLatest(editRaffleContestAction, editRaffleContest)
  yield takeLatest(getRaffleListDataAction, getRaffleListData)
  yield takeLatest(deleteRaffleContestAction, deleteRaffleContest)
  yield takeLatest(getRaffleSingleDataAction, getRaffleSingleData)
  yield takeLatest(uploadPDFThumbnailAction, uploadPDFThumbnail)
  yield takeLatest(getMenuPeriodAction, getMenuPeriod)
  yield takeLatest(addCommentCalenderAction, addCommentCalender)
  yield takeLatest(EditCommentCalenderAction, EditCommentCalender)
  yield takeLatest(EditMenuCategoryAction, editMenuCategory)
  yield takeLatest(AddMenuCategoryAction, addMenuCategory)
  yield takeLatest(DeleteMenuCategoryAction, deleteMenuCategory)
  yield takeLatest(uploadMenuItemAction, uploadMenuItem)
  yield takeLatest(deleteMenuItemAction, deleteMenuItem)
  yield takeLatest(addMenuItemsActions, addMenuItems)
  yield takeLatest(getFoodItemsAction, getFoodItems)
  yield takeLatest(updateFoodItemsAction, updateFoodItems)
  yield takeLatest(moveFoodItemCategoryAction, moveFoodItemCategory)
  yield takeLatest(reorderMenuItemsAction, reorderMenuItems)
  yield takeLatest(reorderMenuCategoriesAction, reorderMenuCategories)
  yield takeLatest(uploadTastingNotesImagesAction, uploadTastingNotesImages)
  yield takeLatest(getLeaderboardDataAction, getLeaderboardData)
  yield takeLatest(getNewLeaderboardDataAction, getNewLeaderboardData)
  yield takeLatest(getSingleUserDataGraphAction, getSingleUserDataGraph)
  yield takeLatest(getBarMenuPeriodAction, getBarMenu)
  yield takeLatest(getWineMenuPeriodAction, getWineMenu)
  yield takeLatest(addWineMenuItemsAction, addWineMenuItems)
  yield takeLatest(getWineItemsAction, getWineItems)
  yield takeLatest(updateWineItemsAction, editWineMenuItem)
  yield takeLatest(deleteWineItemAction, deleteWineMenuItem)
  yield takeLatest(addBarMenuItemsAction, addBarMenuItems)
  yield takeLatest(getBarItemsAction, getBarItems)
  yield takeLatest(updateBarItemsAction, editBarMenuItem)
  yield takeLatest(deleteBarItemAction, deleteBarMenuItem)
  yield takeLatest(AddBarMenuCategoryAction, AddBarMenuCategory)
  yield takeLatest(EditBarMenuCategoryAction, editBarMenuCategory)
  yield takeLatest(DeleteBarMenuCategoryAction, deleteBarMenuCategory)
  yield takeLatest(unArchiveItemsAction, unArchiveItems)
  yield takeLatest(unArchiveBarItemsAction, unArchiveBarItems)
  yield takeLatest(importSpiritItemAction, importSpiritItem)
  yield takeLatest(getSpiritCMSAction, getSpiritCMS)
  yield takeLatest(getArchivedSpiritCMSAction, getArchivedSpiritCMS)
  yield takeLatest(unArchiveSpiritsItemsAction, unArchiveSpiritsItems)
  yield takeLatest(archiveSpiritItemsAction, archiveSpiritItemsAction)
  yield takeLatest(unarchiveWineItemsAction, unarchiveWineItem)
  yield takeLatest(addarchiveSpiritItemsAction, addarchiveSpiritItems)
  yield takeLatest(deleteSpiritMenuItemAction, deleteSpiritMenuItem)
  yield takeLatest(getSpiritItemsAction, getSpiritItems)
  yield takeLatest(updateSpiritItemsAction, updateSpiritItems)
  yield takeLatest(getNewSpiritCountAction, getNewSpiritCount)
  yield takeLatest(getGamificationLeaderboardDataAction, getGamificationLeaderboardData)
  yield takeLatest(getNewGamificationLeaderboardDataAction, getNewGamificationLeaderboardData)
  yield takeLatest(getQuizLeaderBoardDataAction, getQuizLeaderBoardData)
  yield takeLatest(getMenuSubCategoryAction, getMenuSubCategory)
  yield takeLatest(uploadMenuBulkAction, uploadMenuBulk)
  yield takeLatest(AddWineMenuCategoryAction, AddWineMenuCategory)
  yield takeLatest(editWineMenuCategoryAction, editWineMenuCategory)
  yield takeLatest(deleteWineMenuCategoryAction, deleteWineMenuCategory)
  yield takeLatest(unArchiveWineItemsAction, unArchiveWineItems)
  yield takeLatest(uploadDidYouKnowImageAction, uploadDidYouKnowImage)
  yield takeLatest(uploadHistoryMediaAction, uploadHistoryMedia)
  yield takeLatest(searchDidYouKnowImagesAction, searchDidYouKnowImages)
  yield takeLatest(confirmDidYouKnowImageAction, confirmDidYouKnowImage)
  yield takeLatest(getWeeklyChallengeAction, getWeeklyChallenge)
  yield takeLatest(getNextWeeklyChallengeAction, getNextWeeklyChallenge)
  yield takeLatest(getLastWeeklyChallengeAction, getLastWeeklyChallenge)
  yield takeLatest(getPreviousToLastWeeklyChallengeAction, getPreviousToLastWeeklyChallenge)
  yield takeLatest(editWeeklyChallengeAction, editWeeklyChallenge)
  yield takeLatest(getWeeklyQuizAction, getWeeklyQuiz)
  yield takeLatest(getNextWeeklyQuizAction, getNextWeeklyQuiz)
  yield takeLatest(getLastWeeklyQuizAction, getLastWeeklyQuiz)
  yield takeLatest(getPreviousToLastWeeklyQuizAction, getPreviousToLastWeeklyQuiz)
  yield takeLatest(editWeeklyQuizAction, editWeeklyQuiz)
  yield takeLatest(viewWeeklyChallengeAction, viewWeeklyChallenge)
  yield takeLatest(viewWeeklyQuizAction, viewWeeklyQuiz)
  yield takeLatest(getViewChallengeQuestionsAction, getViewChallengeQuestions)
  yield takeLatest(getViewQuizQuestionsAction, getViewQuizQuestions)
  yield takeLatest(deleteChallengeQuestionAction, deleteChallengeQuestion)
  yield takeLatest(editChallengeQuestionAction, editChallengeQuestion)
  yield takeLatest(weeklyCategoryAction, weeklyCategory)
  yield takeLatest(getWeeklyQuestionsBankAction, getWeeklyQuestionsBank)
  yield takeLatest(ReplaceChallengeMenuItemAction, ReplaceChallengeMenuItem)
  yield takeLatest(addWeeklyManualQuestionToBankAction, addWeeklyManualQuestionToBank)
  yield takeLatest(getWeeklyCategoryMenuItemAction, getWeeklyCategoryMenuItem)
  yield takeLatest(generateWeeklyQuestionAction, generateWeeklyQuestion)
  yield takeLatest(addQuestionToChallengeAction, addQuestionToChallenge)
  yield takeLatest(addToWeeklyQuestionBankAction, addToWeeklyQuestionBank)
  yield takeLatest(deleteWeeklyQuestionFromBankAction, deleteWeeklyQuestionFromBank)
  yield takeLatest(generateSoundbitesAction, generateSoundbites)
  yield takeLatest(updateQuizQuestionsAction, updateQuizQuestions)
  yield takeLatest(addWeeklyManualQuestionV2ToBankAction, addWeeklyManualQuestionV2ToBank)
  yield takeLatest(uploadBulkQuestionAction, uploadBulkQuestion)
  yield takeLatest(bulkDeleteQuestionsAction, bulkDeleteQuestions)
  yield takeLatest(getCommentsAction, getComments)
  yield takeLatest(updateCommentStatusAction, updateCommentStatus)
  yield takeLatest(generateDidYouKnowAction, generateDidYouKnow)
  yield takeLatest(generateHistoryAction, generateHistory)
  yield takeLatest(setupWeeklyQuizzesAction, setupWeeklyQuizzes)
  yield takeLatest(setupWeeklyChallengesAction, setupWeeklyChallenges)
  yield takeLatest(swapWeeklyChallengesAction, swapWeeklyChallenges)
  yield takeLatest(generateSoundbiteTextAction, generateSoundbiteText)
  yield takeLatest(aiEnhanceFieldAction, aiEnhanceField)
  yield takeLatest(enhanceDidYouKnowFieldAction, enhanceDidYouKnowField)
  yield takeLatest(removeImageBackgroundAction, removeImageBackground)
  yield takeLatest(getSoundbiteVoiceIdsAction, getSoundbiteVoiceIds)
  yield takeLatest(uploadMenuForReviewAction, uploadMenuForReview)
  yield takeLatest(getReviewMenuCategoriesAction, getReviewMenuCategories)
  yield takeLatest(getReviewMenuPeriodAction, getReviewMenuPeriod)
  yield takeLatest(getReviewBarMenuPeriodAction, getReviewBarMenuPeriod)
  yield takeLatest(getReviewWineMenuPeriodAction, getReviewWineMenuPeriod)
  yield takeLatest(getReviewSpiritCMSAction, getReviewSpiritCMS)
  yield takeLatest(getReviewMenuSubCategoryAction, getReviewMenuSubCategory)
  yield takeLatest(publishReviewMenuAction, publishReviewMenu)
  yield takeLatest(getUploadStatusAction, getUploadStatus)
  yield takeLatest(exportMenuListAction, exportMenuList)
}
